import {
	BlockControls,
	useBlockProps,
	useInnerBlocksProps,
	store as blockEditorStore,
} from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton } from '@wordpress/components';
import { useState, useEffect } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

import Settings from './Settings';
import { TEMPLATE } from '../constants';

import '../style.scss';
import '../editor.scss';

export default function Edit( { attributes, setAttributes, clientId } ) {
	const { flipDirection } = attributes;
	const [ activeSide, setActiveSide ] = useState( 'front' );

	// Auto-switch side when a child block (or its descendant) is selected
	const selectedSide = useSelect(
		( select ) => {
			const { getSelectedBlockClientId, getBlockParents, getBlocks } =
				select( blockEditorStore );
			const selectedId = getSelectedBlockClientId();
			if ( ! selectedId ) {
				return null;
			}

			const innerBlocks = getBlocks( clientId );
			if ( innerBlocks.length < 2 ) {
				return null;
			}

			const frontId = innerBlocks[ 0 ].clientId;
			const backId = innerBlocks[ 1 ].clientId;

			// Check if selected block is the child itself or a descendant
			const parents = getBlockParents( selectedId, true );
			if ( selectedId === frontId || parents.includes( frontId ) ) {
				return 'front';
			}
			if ( selectedId === backId || parents.includes( backId ) ) {
				return 'back';
			}

			return null;
		},
		[ clientId ]
	);

	useEffect( () => {
		if ( selectedSide ) {
			setActiveSide( selectedSide );
		}
	}, [ selectedSide ] );

	const { cardWidth } = attributes;

	const blockProps = useBlockProps( {
		className: `flip-direction-${ flipDirection } active-side-${ activeSide }`,
		style: cardWidth ? { '--flip-width': cardWidth } : undefined,
	} );

	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-flip-card-inner' },
		{ template: TEMPLATE }
	);

	return (
		<>
			<BlockControls>
				<ToolbarGroup>
					<ToolbarButton
						isPressed={ activeSide === 'front' }
						onClick={ () => setActiveSide( 'front' ) }
					>
						{ __( 'Front', 'brandy-blocks' ) }
					</ToolbarButton>
					<ToolbarButton
						isPressed={ activeSide === 'back' }
						onClick={ () => setActiveSide( 'back' ) }
					>
						{ __( 'Back', 'brandy-blocks' ) }
					</ToolbarButton>
				</ToolbarGroup>
			</BlockControls>
			<Settings
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
			<div { ...blockProps }>
				<div { ...innerBlocksProps } />
			</div>
		</>
	);
}
